var map = {
	"./africa/info.vue": [
		"sogk",
		9
	],
	"./club-soft/info.vue": [
		"sd0M",
		11
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6Gdf";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/info lazy ^\.\/.*\/info\.vue$
// module id = 6Gdf
// module chunks = 37